<ng-container *ngIf="filter">
	<span>{{ filter.label }}</span>
	<div class="filter-container" *ngFor="let item of filter.getValues(); trackBy: trackByFunc">
		<mat-icon *ngIf="!isDefaultFilter" color="accent" mat-ripple class="circle-icon-remove" svgIcon="md:remove" (click)="removeValue(item)"></mat-icon>
		<copo-suggestive-item-code-filter [filter]="filter" [placeholder]="filter.placeholder" [filterValue]="item"></copo-suggestive-item-code-filter>
	</div>
</ng-container>
